import { render } from "./Process.vue?vue&type=template&id=4fbec866&scoped=true"
import script from "./Process.vue?vue&type=script&lang=js"
export * from "./Process.vue?vue&type=script&lang=js"

import "./Process.vue?vue&type=style&index=0&id=4fbec866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbec866"]])

export default __exports__